import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
	exportChart,
	getCharts,
	inviteMembers,
	shareByLinkChart,
} from './service';
import { getChartsSuccessAction, getChartsFailureAction } from './action';
import { getChartCounterSuccessAction } from '../ChartCounter/action';

export function* getChartsSaga() {
	try {
		const { data }: AxiosResponse = yield getCharts();
		const { defaultCharts, counter } = data.data;
		yield put(getChartsSuccessAction(defaultCharts));
		yield put(getChartCounterSuccessAction(counter));
	} catch (e) {
		yield put(getChartsFailureAction(e as Error));
	}
}

export function* inviteMembersSaga(action: any) {
	const { type, showSuccessModal, showFailModal } = action.payload;
	try {
		yield inviteMembers(type);
		yield showSuccessModal();
	} catch (e) {
		yield showFailModal();
	}
}

export function* shareByLinkChartSaga(action: any) {
	const { type, callback } = action.payload;
	try {
		const { data } = yield shareByLinkChart(type);
		yield callback && callback(data.data.link);
	} catch (e) {
		yield callback && callback();
	}
}

export function* exportChartSaga(action: any) {
	const { type, showSuccessModal, showFailModal } = action.payload;
	try {
		yield exportChart(type);
		yield showSuccessModal();
	} catch (e) {
		yield showFailModal();
	}
}
